import type { ReactNode } from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import { styles } from '@/shared/app-stepper-form/styles';

/**
 * The help card at the foot of the rail.
 *
 * WHY IT IS ALWAYS VISIBLE
 * ------------------------
 * An operator who is stuck should not have to fail first to discover where to
 * ask. A help affordance that only appears after an error is a help affordance
 * that arrives too late — by then the user has already decided the form is
 * broken.
 *
 * WHY IT IS NOT A BUTTON
 * ----------------------
 * There is nothing to click yet. The assistant is a later phase, and a button
 * that does nothing is worse than no button: it teaches the user that controls
 * in this console are decorative. So this is an informational card that says
 * plainly what is coming, and it will become a real control when the assistant
 * lands.
 *
 * The icon is decorative — `aria-hidden` — because the title beside it already
 * says "Need help?".
 */
export function StepperHelpCard(): ReactNode {
  return (
    <div className={styles.helpCard}>
      <p className={styles.helpCardTitle}>
        <FiHelpCircle aria-hidden="true" className="size-4" />
        Need help?
      </p>
      <p className={styles.helpCardBody}>
        An AI assistant will be available here to answer questions about this form. For now, contact
        your platform administrator.
      </p>
    </div>
  );
}
